import type { OpeningListItem } from "~/lib/objects";

export type OpeningGroupListItem = {
  problemSetId: number;
  name: string;
  openingGroupOrder: number;
  hidden: boolean;
};

export type AdminOpeningGroupListItem = OpeningGroupListItem & {
  activeOpeningCount: number;
};

export function isAdminOpeningGroup(data: unknown): data is AdminOpeningGroupListItem {
  return typeof data === "object" && data !== null &&
    "problemSetId" in data && typeof data.problemSetId === "number" && Number.isSafeInteger(data.problemSetId) && data.problemSetId > 0 &&
    "name" in data && typeof data.name === "string" &&
    "hidden" in data && typeof data.hidden === "boolean" &&
    "openingGroupOrder" in data && typeof data.openingGroupOrder === "number" &&
    "activeOpeningCount" in data && typeof data.activeOpeningCount === "number";
}

export function isAdminOpeningGroupList(data: unknown): data is AdminOpeningGroupListItem[] {
  return Array.isArray(data) && data.every(isAdminOpeningGroup);
}

export type OpeningGroupReference = Pick<
  OpeningGroupListItem,
  "problemSetId" | "name"
>;

export type OpeningProblemListScope =
  | { kind: "group"; problemSetId: number }
  | { kind: "current-problem"; problemId: number };

export type OpeningScopedListResponse = {
  group: OpeningGroupReference | null;
  openings: OpeningListItem[];
};

const CANONICAL_POSITIVE_DECIMAL = /^[1-9]\d*$/;

export function parseOpeningGroupIdString(value: string): number | null {
  if (!CANONICAL_POSITIVE_DECIMAL.test(value)) {
    return null;
  }

  const id = Number(value);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
}
